import React, { useState } from 'react';
import './Courses.css';
import { courses } from '../data/courses';
import CourseModal from './CourseModal';
import { getThumbnailUrl } from '../utils/youtubeUtils';

const Courses = () => {
  const [selectedCourse, setSelectedCourse] = useState(null);

  const handleCourseClick = (course) => {
    setSelectedCourse(course);
  };

  const handleCloseModal = () => {
    setSelectedCourse(null);
  };

  // Get thumbnail - prioritize custom thumbnail (playlist thumbnail), then first lecture
  const getCourseThumbnail = (course) => {
    // 1. Use custom thumbnail if provided (playlist thumbnail from assets)
    if (course.thumbnail) {
      return course.thumbnail;
    }
    
    // 2. Fallback to first lecture thumbnail
    if (course.lectures && course.lectures.length > 0) {
      const firstLecture = course.lectures[0];
      const videoUrl = typeof firstLecture === 'string' ? firstLecture : firstLecture.videoUrl;
      return getThumbnailUrl(videoUrl);
    }
    
    return null;
  };

  return (
    <section id="courses" className="courses">
      <div className="container">
        <div className="section-header">
          <h2 className="section-title">Our Courses</h2>
          <div className="title-underline"></div>
          <p className="section-subtitle">
            Explore our comprehensive Islamic education courses. Click on any course to view all lectures.
          </p>
        </div>

        <div className="courses-grid">
          {courses.map((course) => {
            const thumbnail = getCourseThumbnail(course);
            return (
              <div
                key={course.id}
                className="course-card"
                onClick={() => handleCourseClick(course)}
              >
                <div className="course-thumbnail">
                  {thumbnail ? (
                    <img src={thumbnail} alt={course.title} />
                  ) : (
                    <div className="course-thumbnail-placeholder">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="currentColor"
                      >
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z" />
                      </svg>
                    </div>
                  )}
                  <div className="course-play-overlay">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                    >
                      <path d="M8 5v14l11-7z" />
                    </svg>
                  </div>
                </div>
                <div className="course-info">
                  <h3 className="course-title">{course.title}</h3>
                  <p className="course-description">{course.description}</p>
                  <div className="course-meta">
                    <span className="course-lecture-count">
                      {course.lectures?.length || 0} Lectures
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {selectedCourse && (
        <CourseModal
          course={selectedCourse}
          onClose={handleCloseModal}
        />
      )}
    </section>
  );
};

export default Courses;
